exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-7d98958a]{width:12px;height:12px;border-radius:50%;font-size:8px;display:inline-flex;justify-content:center;align-items:center;color:#fff;margin-left:4px;cursor:default;--tw-bg-opacity:1;background-color:rgb(43 81 130/var(--tw-bg-opacity))}", ""]);

// exports
